const THRESHOLDS = {
  ms: 300, // ms since the first click,
  distance: 5 // pixels threshold
}

/*
 * Given an initial click object that contains `ms` for the click and `x`, `y`
 * coords describing the click coordinates and `coords` describing the current
 * mouse position, returns if it's a valid drag.
 */
export default function (initial, coords) {
  if (!initial) {
    // Initial click doesn't exist, so they've been dragging, of course it's
    // valid
    return true
  }

  return (performance.now() - initial.ms) > THRESHOLDS.ms ||
          Math.abs(coords.x - initial.x) > THRESHOLDS.distance ||
          Math.abs(coords.y - initial.y) > THRESHOLDS.distance
}
